import React from 'react';
import ReactDom from 'react-dom';
import Moment from 'moment';

import Const from 'fw_const';
import Utils from 'utils';

const ANNOTATION_DISPLAY_DURATION = 2;

const SORT_TIME = 'time';
const SORT_NEW  = 'new';
const SORT_OLD  = 'old';

export class VideoInstructionModal extends React.Component {
  constructor(props) {
    super(props);
    this.videoARef        = React.createRef();
    this.videoBRef        = React.createRef();
    this.timelineRef      = React.createRef();
    this.overlayCanvasRef = React.createRef();
    this.overlayCavnasB   = React.createRef();
    this.previewVideoRef  = React.createRef();
    this.previewCanvasRef = React.createRef();

    const historyList = this._buildHistoryList(props);
    const defaultOldIdx = historyList.length >= 2 ? 1 : -1;

    let savedComments = [];
    try {
      const contents = props.contents || {};
      let revise_movie_option = contents.revise_movie_option;

      if (!revise_movie_option) {
        const detail  = props.detail || {};
        const itemNo  = contents.item_no || 1;
        const itemIdx = itemNo - 1;
        const mediaArr = detail.draft_media && detail.draft_media[contents.contents_id];
        if (Array.isArray(mediaArr) && mediaArr[itemIdx]) {
          revise_movie_option = mediaArr[itemIdx].revise_movie_option;
        }
      }

      if (revise_movie_option) {
        const parsed = JSON.parse(revise_movie_option);
        if (parsed && Array.isArray(parsed.comments)) savedComments = parsed.comments;
      }
    } catch (e) { }

    this.state = {
      commentText:       '',
      isPlaying:         false,
      currentTime:       0,
      durationA:         0,
      durationB:         0,
      drawingTool:       null,
      isDrawing:         false,
      annotations:       [],
      currentAnnotation: null,
      annotationColor:   '#ff4081',
      pendingTextPos:    null,
      textInput:         '',
      showTextInput:     false,
      textCursorPos:     null,
      selectedAnnotationIdx:  -1,
      dragStartPos:           null,
      dragOrigAnnotations:    null,
      editingAnnotationIdx:   -1,
      isSaving:          false,
      comments:          savedComments,
      commentTextManuallyEdited: false,
      editingCommentId: null,
      sortOrder:         SORT_TIME,
      showPreview:       false,
      previewTime:       0,
      previewDuration:   0,
      previewPlaying:    false,
      historyList:       historyList,
      selectedOldIdx:    defaultOldIdx,
      // ★ 前バージョンが存在する場合はデフォルトON
      showOldTimeline:   historyList.length >= 2,
    };

    this._previewRafId = null;
  }

  _buildHistoryList(props) {
    const detail   = props.detail   || {};
    const contents = props.contents || {};
    const table    = props.table;

    if (table === 'draft_caption') return [];

    try {
      const allHistory = detail.draft_media_history && detail.draft_media_history[contents.contents_id];
      if (!allHistory || !Array.isArray(allHistory) || allHistory.length === 0) return [];

      const itemNo  = contents.item_no || 1;
      const itemIdx = itemNo - 1;

      const hasItemNo = allHistory.some(d => d.item_no != null);

      if (hasItemNo) {
        const filtered = allHistory.filter(d => d.item_no === itemNo);
        return filtered.length > 0 ? filtered : [];
      } else {
        const entry = allHistory[itemIdx];
        return entry ? [entry] : [];
      }
    } catch (e) {
      return [];
    }
  }

  _getVersionLabel(entry, detail) {
    if (!entry) return '';
    try {
      const dl = detail.draft_lists || {};
      const d  = dl[entry.draft_id];
      if (d && d.version != null) return `v${d.version}`;
    } catch (e) {}
    return `draft#${entry.draft_id}`;
  }

  _getCommentsFromEntry(entry) {
    if (!entry || !entry.revise_movie_option) return [];
    try {
      const parsed = JSON.parse(entry.revise_movie_option);
      if (parsed && Array.isArray(parsed.comments)) return parsed.comments;
    } catch (e) {}
    return [];
  }

  _redrawOldVersionAnnotations(currentTime) {
    const canvas = this.overlayCavnasB.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const { historyList, selectedOldIdx } = this.state;
    if (selectedOldIdx < 0) return;
    const oldEntry = historyList[selectedOldIdx];
    const oldComments = this._getCommentsFromEntry(oldEntry);
    if (!oldComments.length) return;

    const visible = oldComments.filter(c => {
      const t = c.timeSec || 0;
      return currentTime >= t && currentTime <= t + ANNOTATION_DISPLAY_DURATION;
    });
    visible.forEach(c => {
      if (c.annotations && c.annotations.length > 0)
        c.annotations.forEach(a => this._drawAnnotation(ctx, a, canvas.width, canvas.height));
    });
  }

  saveReviseMovieOption(newComments) {
    const payload = { comments: newComments };
    const textSummary = this.buildTextSummary(newComments);
    try {
      this.props.change_ev.bind(this)(null, JSON.stringify(payload));
      setTimeout(() => { this._doRedrawMain(); }, 500);
    } catch (e) { }
  }

  handleAddComment() {
    const { commentText, currentTime, annotations, comments } = this.state;
    const base     = this.props.base || {};
    const userData = base.userData || {};
    if (!commentText.trim() && annotations.length === 0) return;

    const now  = new Date();
    const pad2 = n => String(n).padStart(2, '0');
    const dateStr = `${now.getFullYear()}/${pad2(now.getMonth()+1)}/${pad2(now.getDate())} ${pad2(now.getHours())}:${pad2(now.getMinutes())}`;

    const BADGE_COLORS = ['#0066ff','#ff4081','#00bfa5','#7c4dff','#ff9100','#00b0ff'];
    const badgeColor   = BADGE_COLORS[(userData.id || 0) % BADGE_COLORS.length];

    const newComment = {
      id:          Date.now(),
      user_id:     userData.id   || null,
      author:      userData.name || 'unknown',
      avatar:      userData.thumbnail || '',
      date:        dateStr,
      timecode:    this.formatTime(currentTime),
      timeSec:     currentTime,
      content:     commentText.trim(),
      badgeColor:  badgeColor,
      annotations: annotations.map(a => ({ ...a })),
    };

    const newComments = [newComment, ...comments];
    this.clearCanvas();
    this.setState(
      { comments: newComments, commentText: '', annotations: [], drawingTool: null, currentAnnotation: null, commentTextManuallyEdited: false },
      () => { this._doRedrawMain(); }
    );
    this.saveReviseMovieOption(newComments);
  }

  buildTextSummary(commentsArr) {
    const groupMap = {};
    commentsArr.forEach(c => {
      const secKey = Math.floor(c.timeSec || 0);
      if (!groupMap[secKey]) groupMap[secKey] = [];
      if (c.content) groupMap[secKey].push(c.content);
    });
    const sortedKeys = Object.keys(groupMap).map(Number).sort((a, b) => a - b);
    const autoText = sortedKeys
      .map(sec => {
        const lines = groupMap[sec].filter(Boolean);
        return lines.length > 0 ? `${this.formatTime(sec)}\n${lines.join('\n')}` : null;
      })
      .filter(Boolean)
      .join('\n');

    const rawRevise = ((this.props.contents && this.props.contents.revise_message) || '').trim();
    if (!rawRevise) return autoText;

    const autoBlocks = {};
    sortedKeys.forEach(sec => {
      const timeLabel = this.formatTime(sec);
      autoBlocks[timeLabel] = new Set(groupMap[sec].filter(Boolean));
    });

    const lines = rawRevise.split('\n');
    const TIME_RE = /^\d+:\d{2}(:\d{2})?$/;

    const reviseBlocks = [];
    let currentBlock = null;
    for (const line of lines) {
      const trimmed = line.trim();
      if (TIME_RE.test(trimmed)) {
        if (currentBlock) reviseBlocks.push(currentBlock);
        currentBlock = { time: trimmed, texts: [] };
      } else if (currentBlock) {
        if (trimmed) currentBlock.texts.push(trimmed);
      } else {
        return rawRevise;
      }
    }
    if (currentBlock) reviseBlocks.push(currentBlock);

    if (reviseBlocks.length === 0) return rawRevise;

    for (const block of reviseBlocks) {
      const autoSet = autoBlocks[block.time];
      if (!autoSet) return rawRevise;
      for (const text of block.texts) {
        if (!autoSet.has(text)) return rawRevise;
      }
    }

    return autoText;
  }

  handleDeleteComment(commentId) {
    const { comments } = this.state;
    const newComments = comments.filter(c => c.id !== commentId);
    this.setState({ comments: newComments });
    this.saveReviseMovieOption(newComments);
  }

  handleEditComment(comment) {
    this._doSeek(comment.timeSec || 0);
    this.setState({
      editingCommentId:      comment.id,
      commentText:           comment.content || '',
      annotations:           comment.annotations ? comment.annotations.map(a => ({ ...a })) : [],
      drawingTool:           null,
      selectedAnnotationIdx: -1,
      dragStartPos:          null,
      dragOrigAnnotations:   null,
      commentTextManuallyEdited: true,
    }, () => {
      this.redrawAnnotations(null, this.state.annotations);
    });
  }

  handleSaveEditedComment() {
    const { editingCommentId, commentText, annotations, comments } = this.state;
    if (!editingCommentId) return;

    const newComments = comments.map(c => {
      if (c.id !== editingCommentId) return c;
      return { ...c, content: commentText.trim(), annotations: annotations.map(a => ({ ...a })) };
    });

    this.clearCanvas();
    this.setState(
      { comments: newComments, commentText: '', annotations: [], drawingTool: null, currentAnnotation: null, editingCommentId: null, commentTextManuallyEdited: false },
      () => { this._doRedrawMain(); }
    );
    this.saveReviseMovieOption(newComments);
  }

  handleCancelEdit() {
    this.clearCanvas();
    this.setState(
      { editingCommentId: null, commentText: '', annotations: [], drawingTool: null, currentAnnotation: null, commentTextManuallyEdited: false },
      () => { this._doRedrawMain(); }
    );
  }

  getSortedComments() {
    const { comments, sortOrder } = this.state;
    const arr = [...comments];
    if (sortOrder === SORT_TIME) arr.sort((a, b) => (a.timeSec || 0) - (b.timeSec || 0));
    else if (sortOrder === SORT_NEW) arr.sort((a, b) => b.id - a.id);
    else if (sortOrder === SORT_OLD) arr.sort((a, b) => a.id - b.id);
    return arr;
  }

  handleCommentChange(e) {
    this.setState({ commentText: e.target.value, commentTextManuallyEdited: true });
  }

  togglePlay() {
    const { isPlaying, annotations } = this.state;
    const videoA = this.videoARef.current;
    const videoB = this.videoBRef.current;
    if (!videoA) return;

    if (isPlaying) {
      videoA.pause();
      if (videoB) videoB.pause();
      this.setState({ isPlaying: false });
    } else {
      if (annotations.length > 0) {
        const ok = window.confirm('現在の描き込みは保存されていません。\n再生を開始すると描き込みが消えますが、よろしいですか？');
        if (!ok) return;
        this.clearAnnotations();
      }
      if (videoB && videoB.currentTime >= videoB.duration) videoB.currentTime = 0;
      videoA.play().catch(() => {});
      if (videoB) videoB.play().catch(() => {});
      this.setState({ isPlaying: true });
    }
  }

  handleTimeUpdate() {
    const videoA = this.videoARef.current;
    const videoB = this.videoBRef.current;
    if (!videoA) return;
    const currentTime = videoA.currentTime;
    if (!isFinite(currentTime)) return;
    this.setState({ currentTime }, () => { this._doRedrawMain(); });
    if (videoB && isFinite(videoB.duration) && videoB.duration > 0) {
      const syncTime = Math.min(currentTime, videoB.duration);
      if (Math.abs(videoB.currentTime - syncTime) > 0.3) videoB.currentTime = syncTime;
    }
    this._redrawOldVersionAnnotations(currentTime);
  }

  handleLoadedMetadata() {
    const videoA = this.videoARef.current;
    const videoB = this.videoBRef.current;
    this.setState({
      durationA: videoA && isFinite(videoA.duration) ? videoA.duration : 0,
      durationB: videoB && isFinite(videoB.duration) ? videoB.duration : 0,
    });
  }

  handleVideoEnded() { this.setState({ isPlaying: false }); }

  _doSeek(newTime) {
    const videoA = this.videoARef.current;
    const videoB = this.videoBRef.current;
    if (!videoA || !isFinite(newTime)) return;
    videoA.currentTime = newTime;
    if (videoB && isFinite(videoB.duration) && videoB.duration > 0)
      videoB.currentTime = Math.min(newTime, videoB.duration);
    this.setState({ currentTime: newTime }, () => { this._doRedrawMain(); });
  }

  _seekWithAnnotationGuard(newTime) {
    const { annotations } = this.state;
    if (annotations.length > 0) {
      const ok = window.confirm('現在の描き込みは保存されていません。\n別の時間に移動すると描き込みが消えますが、よろしいですか？');
      if (!ok) return;
      this.clearAnnotations();
    }
    this._doSeek(newTime);
  }

  handleSeek(e) {
    const { durationA } = this.state;
    if (!durationA || !isFinite(durationA)) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const pct  = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    this._seekWithAnnotationGuard(pct * durationA);
  }

  handleIconSeek(timeSec) {
    this._seekWithAnnotationGuard(timeSec || 0);
  }

  // ★ 旧版タイムライン軸クリック: durationB 基準でシーク（videoA/B 両方動かす）
  handleOldSeek(e) {
    const { durationB } = this.state;
    if (!durationB || !isFinite(durationB)) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const pct  = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    this._seekWithAnnotationGuard(pct * durationB);
  }

  formatTime(seconds) {
    if (!isFinite(seconds) || seconds == null || isNaN(seconds)) return '0:00';
    const t  = Math.floor(seconds);
    const h  = Math.floor(t / 3600);
    const m  = Math.floor((t % 3600) / 60);
    const s  = t % 60;
    const ss = String(s).padStart(2, '0');
    if (h > 0) return `${h}:${String(m).padStart(2,'0')}:${ss}`;
    return `${m}:${ss}`;
  }

  setDrawingTool(tool) {
    if (this.state.isPlaying) return;
    const { drawingTool } = this.state;
    this.setState({ drawingTool: drawingTool === tool ? null : tool, isDrawing: false, currentAnnotation: null, showTextInput: false, textCursorPos: null });
  }

  getCanvasRelativePos(e, canvas) {
    const rect = canvas.getBoundingClientRect();
    return { x: (e.clientX - rect.left) / rect.width, y: (e.clientY - rect.top) / rect.height };
  }

  _handleTextCursorMove(e, canvas) {
    const rect = canvas.getBoundingClientRect();
    this.setState({ textCursorPos: { x: e.clientX - rect.left, y: e.clientY - rect.top } });
  }

  _hitTest(pos, ann, W, H) {
    const MARGIN = 12 / W;
    if (ann.type === 'circle') {
      const cx = (ann.x + ann.x2) / 2, cy = (ann.y + ann.y2) / 2;
      const rx = Math.abs(ann.x2 - ann.x) / 2 + MARGIN;
      const ry = Math.abs(ann.y2 - ann.y) / 2 + MARGIN;
      const dx = (pos.x - cx) / rx, dy = (pos.y - cy) / ry;
      return dx*dx + dy*dy <= 1;
    }
    if (ann.type === 'arrow') {
      const x1=ann.x, y1=ann.y, x2=ann.x2, y2=ann.y2;
      const len2 = (x2-x1)*(x2-x1) + (y2-y1)*(y2-y1);
      if (len2 === 0) return false;
      const t = Math.max(0, Math.min(1, ((pos.x-x1)*(x2-x1)+(pos.y-y1)*(y2-y1)) / len2));
      const px = x1 + t*(x2-x1), py = y1 + t*(y2-y1);
      const dist = Math.sqrt((pos.x-px)*(pos.x-px)+(pos.y-py)*(pos.y-py));
      return dist < MARGIN * 2;
    }
    if (ann.type === 'text') {
      const textW = 80 / W, textH = 20 / H;
      return pos.x >= ann.x - MARGIN && pos.x <= ann.x + textW + MARGIN &&
             pos.y >= ann.y - textH  && pos.y <= ann.y + MARGIN;
    }
    return false;
  }

  _moveAnnotation(ann, dx, dy) {
    if (ann.type === 'text') return { ...ann, x: ann.x + dx, y: ann.y + dy };
    return { ...ann, x: ann.x + dx, y: ann.y + dy, x2: ann.x2 + dx, y2: ann.y2 + dy };
  }

  _drawingHandler(type, e) {
    const canvas = this.overlayCanvasRef.current;
    if (!canvas) return;
    const { drawingTool, annotationColor, currentTime, isPlaying, annotations } = this.state;
    if (isPlaying) return;

    if (!drawingTool) {
      const pos = this.getCanvasRelativePos(e, canvas);
      const W = canvas.clientWidth, H = canvas.clientHeight;

      if (type === 'mousedown') {
        e.stopPropagation();
        const { selectedAnnotationIdx, annotations } = this.state;

        if (selectedAnnotationIdx >= 0) {
          const ann = annotations[selectedAnnotationIdx];
          let bx, by, bw;
          if (ann.type === 'circle') {
            bx = Math.min(ann.x, ann.x2) * W - 4;
            by = Math.min(ann.y, ann.y2) * H - 4;
            bw = Math.abs(ann.x2 - ann.x) * W + 8;
          } else if (ann.type === 'arrow') {
            bx = Math.min(ann.x, ann.x2) * W - 8;
            by = Math.min(ann.y, ann.y2) * H - 8;
            bw = Math.abs(ann.x2 - ann.x) * W + 16;
          } else {
            bx = ann.x * W - 4; by = ann.y * H - 18; bw = 100;
          }
          const deleteX = bx + bw, deleteY = by;
          const px = pos.x * W, py = pos.y * H;
          const distToDelete = Math.sqrt((px - deleteX)**2 + (py - deleteY)**2);
          if (distToDelete <= 10) {
            const newAnnotations = annotations.filter((_, i) => i !== selectedAnnotationIdx);
            this.setState({ annotations: newAnnotations, selectedAnnotationIdx: -1 });
            this.redrawAnnotations(null, newAnnotations);
            return;
          }
        }

        let hitIdx = -1;
        for (let i = annotations.length - 1; i >= 0; i--) {
          if (this._hitTest(pos, annotations[i], W, H)) { hitIdx = i; break; }
        }

        if (hitIdx >= 0) {
          this.setState({ selectedAnnotationIdx: hitIdx, dragStartPos: pos, dragOrigAnnotations: annotations.map(a => ({ ...a })) });
        } else {
          this.setState({ selectedAnnotationIdx: -1 });
        }
      } else if (type === 'mousemove') {
        const { selectedAnnotationIdx, dragStartPos, dragOrigAnnotations } = this.state;
        if (selectedAnnotationIdx == null || selectedAnnotationIdx < 0 || !dragStartPos) return;
        const dx = pos.x - dragStartPos.x, dy = pos.y - dragStartPos.y;
        const newAnnotations = dragOrigAnnotations.map((a, i) =>
          i === selectedAnnotationIdx ? this._moveAnnotation(a, dx, dy) : a
        );
        this.setState({ annotations: newAnnotations });
        this.redrawAnnotations(null, newAnnotations);
      } else if (type === 'mouseup') {
        const { selectedAnnotationIdx, dragStartPos } = this.state;
        if (selectedAnnotationIdx == null || selectedAnnotationIdx < 0) return;
        if (dragStartPos) {
          const dist = Math.sqrt(Math.pow(pos.x - dragStartPos.x, 2) + Math.pow(pos.y - dragStartPos.y, 2));
          if (dist < 0.005 && annotations[selectedAnnotationIdx] && annotations[selectedAnnotationIdx].type === 'text') {
            const ann = annotations[selectedAnnotationIdx];
            this.setState({ editingAnnotationIdx: selectedAnnotationIdx, pendingTextPos: { x: ann.x, y: ann.y }, textInput: ann.text || '', showTextInput: true, textCursorPos: null });
          }
        }
        this.setState({ dragStartPos: null, dragOrigAnnotations: null });
      }
      return;
    }

    if (drawingTool === 'text') {
      if (type === 'mousemove')  { this._handleTextCursorMove(e, canvas); return; }
      if (type === 'mouseleave') { this.setState({ textCursorPos: null }); return; }
      if (type === 'mousedown')  {
        e.stopPropagation();
        const pos = this.getCanvasRelativePos(e, canvas);
        this.setState({ pendingTextPos: pos, showTextInput: true, textCursorPos: null });
      }
      return;
    }

    if (type === 'mousedown') {
      e.stopPropagation();
      const pos = this.getCanvasRelativePos(e, canvas);
      this.setState({ isDrawing: true, currentAnnotation: { type: drawingTool, x: pos.x, y: pos.y, x2: pos.x, y2: pos.y, color: annotationColor, frameTime: currentTime } });
    } else if (type === 'mousemove') {
      if (!this.state.isDrawing) return;
      const pos = this.getCanvasRelativePos(e, canvas);
      const ann = { ...this.state.currentAnnotation, x2: pos.x, y2: pos.y };
      this.setState({ currentAnnotation: ann });
      this.redrawAnnotations(ann);
    } else if (type === 'mouseup') {
      if (!this.state.isDrawing) return;
      const pos = this.getCanvasRelativePos(e, canvas);
      const ann = { ...this.state.currentAnnotation, x2: pos.x, y2: pos.y };
      const newAnnotations = [...this.state.annotations, ann];
      this.setState({ annotations: newAnnotations, isDrawing: false, currentAnnotation: null },
        () => { this.redrawAnnotations(null, newAnnotations); });
    }
  }

  commitTextAnnotation() {
    const { pendingTextPos, textInput, annotationColor, currentTime, annotations, commentText, commentTextManuallyEdited, editingAnnotationIdx } = this.state;

    if (!pendingTextPos || !textInput.trim()) {
      this.setState({ showTextInput: false, pendingTextPos: null, textInput: '', textCursorPos: null, editingAnnotationIdx: -1 });
      return;
    }
    const drawnText = textInput.trim();

    let newAnnotations;
    if (editingAnnotationIdx >= 0) {
      newAnnotations = annotations.map((a, i) => i === editingAnnotationIdx ? { ...a, text: drawnText } : a);
    } else {
      const ann = { type: 'text', x: pendingTextPos.x, y: pendingTextPos.y, text: drawnText, color: annotationColor, frameTime: currentTime };
      newAnnotations = [...annotations, ann];
    }

    let newCommentText = commentText;
    if (!commentTextManuallyEdited && editingAnnotationIdx < 0) {
      newCommentText = commentText.trim() ? `${commentText.trim()}\n${drawnText}` : drawnText;
    }

    this.setState({ annotations: newAnnotations, showTextInput: false, pendingTextPos: null, textInput: '', textCursorPos: null, commentText: newCommentText, editingAnnotationIdx: -1 });
    this.redrawAnnotations(null, newAnnotations);
  }

  clearCanvas() {
    const canvas = this.overlayCanvasRef.current;
    if (canvas) { const ctx = canvas.getContext('2d'); ctx.clearRect(0, 0, canvas.width, canvas.height); }
  }

  clearAnnotations() {
    this.setState(
      { annotations: [], currentAnnotation: null, drawingTool: null, selectedAnnotationIdx: -1, dragStartPos: null, dragOrigAnnotations: null },
      () => { this._doRedrawMain(); }
    );
  }

  redrawAnnotations(tempAnn, anns) {
    const canvas = this.overlayCanvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const list = anns !== undefined ? anns : this.state.annotations;
    list.forEach((a, i) => {
      this._drawAnnotation(ctx, a, canvas.width, canvas.height);
      if (i === this.state.selectedAnnotationIdx) this._drawSelectionHandle(ctx, a, canvas.width, canvas.height);
    });
    if (tempAnn) this._drawAnnotation(ctx, tempAnn, canvas.width, canvas.height);
  }

  _drawSelectionHandle(ctx, ann, W, H) {
    ctx.save();
    ctx.setLineDash([4, 3]);
    ctx.strokeStyle = '#1976D2';
    ctx.lineWidth   = 1.5;

    let bx, by, bw, bh;
    if (ann.type === 'circle') {
      bx = Math.min(ann.x, ann.x2) * W - 4; by = Math.min(ann.y, ann.y2) * H - 4;
      bw = Math.abs(ann.x2 - ann.x) * W + 8; bh = Math.abs(ann.y2 - ann.y) * H + 8;
    } else if (ann.type === 'arrow') {
      bx = Math.min(ann.x, ann.x2) * W - 8; by = Math.min(ann.y, ann.y2) * H - 8;
      bw = Math.abs(ann.x2 - ann.x) * W + 16; bh = Math.abs(ann.y2 - ann.y) * H + 16;
    } else {
      bx = ann.x * W - 4; by = ann.y * H - 18; bw = 100; bh = 24;
    }

    ctx.strokeRect(bx, by, bw, bh);

    const cx = bx + bw, cy = by;
    ctx.setLineDash([]);
    ctx.fillStyle = '#e53935';
    ctx.beginPath(); ctx.arc(cx, cy, 7, 0, 2*Math.PI); ctx.fill();
    ctx.strokeStyle = '#fff'; ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.moveTo(cx-3.5, cy-3.5); ctx.lineTo(cx+3.5, cy+3.5); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(cx+3.5, cy-3.5); ctx.lineTo(cx-3.5, cy+3.5); ctx.stroke();
    ctx.restore();
  }

  _drawSavedAnnotations(currentTime) {
    const canvas = this.overlayCanvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const { comments } = this.state;
    const visible = comments.filter(c => {
      const t = c.timeSec || 0;
      return currentTime >= t && currentTime <= t + ANNOTATION_DISPLAY_DURATION;
    });
    visible.forEach(c => {
      if (c.annotations && c.annotations.length > 0)
        c.annotations.forEach(a => this._drawAnnotation(ctx, a, canvas.width, canvas.height));
    });
  }

  _doRedrawMain() {
    const { annotations, currentTime } = this.state;
    if (annotations.length > 0) { this.redrawAnnotations(null, annotations); return; }
    this._drawSavedAnnotations(currentTime);
  }

  _startRafLoop() {
    const loop = () => {
      this._rafLoopId = requestAnimationFrame(loop);
      const canvas = this.overlayCanvasRef.current;
      if (!canvas) return;
      const box = canvas.parentElement;
      if (!box) return;
      const w = box.clientWidth, h = box.clientHeight;
      if (w > 0 && h > 0 && (canvas.width !== w || canvas.height !== h)) {
        canvas.width = w; canvas.height = h;
        this._doRedrawMain();
      }
    };
    this._rafLoopId = requestAnimationFrame(loop);
  }

  _stopRafLoop() {
    if (this._rafLoopId) { cancelAnimationFrame(this._rafLoopId); this._rafLoopId = null; }
  }

  _syncOldCanvas() {
    const canvas = this.overlayCavnasB.current;
    const box    = canvas ? canvas.parentElement : null;
    if (!canvas || !box) return;
    const w = box.clientWidth, h = box.clientHeight;
    if (canvas.width !== w || canvas.height !== h) {
      canvas.width = w; canvas.height = h;
      this._redrawOldVersionAnnotations(this.state.currentTime);
    }
  }

  _drawAnnotation(ctx, ann, W, H) {
    const mainColor = ann.color || '#ff4081';
    ctx.setLineDash([]);

    if (ann.type === 'circle') {
      const cx = ann.x * W, cy = ann.y * H, ex = ann.x2 * W, ey = ann.y2 * H;
      const rx = Math.abs(ex - cx) / 2, ry = Math.abs(ey - cy) / 2;
      const ox = (cx + ex) / 2, oy = (cy + ey) / 2;
      if (rx < 1 && ry < 1) return;
      ctx.lineWidth = 5; ctx.strokeStyle = 'rgba(0,0,0,0.55)';
      ctx.beginPath(); ctx.ellipse(ox, oy, Math.max(rx, 2), Math.max(ry, 2), 0, 0, 2 * Math.PI); ctx.stroke();
      ctx.lineWidth = 2.5; ctx.strokeStyle = mainColor;
      ctx.beginPath(); ctx.ellipse(ox, oy, Math.max(rx, 2), Math.max(ry, 2), 0, 0, 2 * Math.PI); ctx.stroke();
    } else if (ann.type === 'arrow') {
      const x1 = ann.x * W, y1 = ann.y * H, x2 = ann.x2 * W, y2 = ann.y2 * H;
      const dx = x2 - x1, dy = y2 - y1, len = Math.sqrt(dx*dx + dy*dy);
      if (len < 2) return;
      const angle = Math.atan2(dy, dx);
      const headLen = Math.min(18, len * 0.4);

      ctx.lineWidth = 5; ctx.strokeStyle = 'rgba(0,0,0,0.55)'; ctx.fillStyle = 'rgba(0,0,0,0.55)';
      ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(x2, y2);
      ctx.lineTo(x2 - headLen * Math.cos(angle - Math.PI/7), y2 - headLen * Math.sin(angle - Math.PI/7));
      ctx.lineTo(x2 - headLen * Math.cos(angle + Math.PI/7), y2 - headLen * Math.sin(angle + Math.PI/7));
      ctx.closePath(); ctx.fill();

      ctx.lineWidth = 2.5; ctx.strokeStyle = mainColor; ctx.fillStyle = mainColor;
      ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(x2, y2);
      ctx.lineTo(x2 - headLen * Math.cos(angle - Math.PI/7), y2 - headLen * Math.sin(angle - Math.PI/7));
      ctx.lineTo(x2 - headLen * Math.cos(angle + Math.PI/7), y2 - headLen * Math.sin(angle + Math.PI/7));
      ctx.closePath(); ctx.fill();
    } else if (ann.type === 'text') {
      ctx.font = 'bold 15px sans-serif'; ctx.lineWidth = 3;
      ctx.strokeStyle = 'rgba(0,0,0,0.6)'; ctx.strokeText(ann.text, ann.x * W, ann.y * H);
      ctx.fillStyle = mainColor; ctx.fillText(ann.text, ann.x * W, ann.y * H);
    }
  }

  openPreview() { this.setState({ showPreview: true, previewTime: 0, previewPlaying: false }); }

  closePreview() {
    const vid = this.previewVideoRef.current;
    if (vid) vid.pause();
    if (this._previewRafId) { cancelAnimationFrame(this._previewRafId); this._previewRafId = null; }
    this.setState({ showPreview: false, previewPlaying: false });
  }

  togglePreviewPlay() {
    const vid = this.previewVideoRef.current;
    if (!vid) return;
    const { previewPlaying } = this.state;
    if (previewPlaying) {
      vid.pause(); this.setState({ previewPlaying: false });
    } else {
      vid.play().catch(() => {});
      this.setState({ previewPlaying: true });
      this._startPreviewLoop();
    }
  }

  _startPreviewLoop() {
    const loop = () => {
      const vid = this.previewVideoRef.current;
      if (!vid || !this.state.previewPlaying) return;
      const t = vid.currentTime;
      if (isFinite(t)) { this.setState({ previewTime: t }); this._drawPreviewAnnotations(t); }
      this._previewRafId = requestAnimationFrame(loop);
    };
    this._previewRafId = requestAnimationFrame(loop);
  }

  handlePreviewSeek(e) {
    const vid = this.previewVideoRef.current;
    const { previewDuration } = this.state;
    if (!vid || !previewDuration) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const t = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width)) * previewDuration;
    if (!isFinite(t)) return;
    vid.currentTime = t;
    this.setState({ previewTime: t });
    this._drawPreviewAnnotations(t);
  }

  handlePreviewMetadata() {
    const vid = this.previewVideoRef.current;
    if (vid && isFinite(vid.duration)) this.setState({ previewDuration: vid.duration });
  }

  handlePreviewEnded() {
    if (this._previewRafId) { cancelAnimationFrame(this._previewRafId); this._previewRafId = null; }
    this.setState({ previewPlaying: false });
  }

  _drawPreviewAnnotations(currentTime) {
    const canvas = this.previewCanvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const { comments } = this.state;
    const visible = comments.filter(c => {
      const t = c.timeSec || 0;
      return currentTime >= t && currentTime <= t + ANNOTATION_DISPLAY_DURATION;
    });
    visible.forEach(c => {
      if (c.annotations && c.annotations.length > 0)
        c.annotations.forEach(a => this._drawAnnotation(ctx, a, canvas.width, canvas.height));
    });
  }

  componentDidMount() { this._startRafLoop(); }

  componentDidUpdate(prevProps, prevState) {
    this._syncOldCanvas();

    if (this.state.showTextInput && !prevState.showTextInput) {
      setTimeout(() => {
        const input = document.querySelector('.vim-textpop-input');
        if (input) input.focus();
      }, 30);
    }

    if (prevState.selectedOldIdx !== this.state.selectedOldIdx) {
      this._redrawOldVersionAnnotations(this.state.currentTime);
    }

    if (prevState.comments !== this.state.comments) {
      this._doRedrawMain();
    }
  }

  componentWillUnmount() {
    this._stopRafLoop();
    if (this._previewRafId) cancelAnimationFrame(this._previewRafId);
  }

  handleCloseWithGuard() {
    const { commentText, annotations } = this.state;
    const isDirty = commentText.trim().length > 0 || annotations.length > 0;
    if (isDirty) {
      const ok = window.confirm('入力中の修正指示または描き込みが破棄されます。\nモーダルを閉じてもよろしいですか？');
      if (!ok) return;
    }
    this.props.close_ev(false);
  }

  render() {
    const detail   = this.props.detail || {};
    const base     = this.props.base || {};
    const userData = base.userData || {};
    const {
      currentTime, durationA, durationB, isPlaying,
      drawingTool, annotations, annotationColor,
      showTextInput, pendingTextPos, textInput, textCursorPos,
      commentText, isSaving, sortOrder,
      showPreview, previewTime, previewDuration, previewPlaying,
      historyList, selectedOldIdx, showOldTimeline,
      editingCommentId,
    } = this.state;

    const sortedComments = this.getSortedComments();
    const allComments    = this.state.comments;

    const entryA     = historyList[0] || null;
    const entryB     = selectedOldIdx >= 0 ? historyList[selectedOldIdx] : null;
    const videoA_src = entryA ? (entryA.media_url || '') : 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4';
    const videoB_src = entryB ? (entryB.media_url || '') : 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4';
    const videoA_ver = this._getVersionLabel(entryA, detail);
    const videoB_ver = this._getVersionLabel(entryB, detail);

    const oldVersionOptions = historyList.slice(1).map((entry, i) => ({
      idx: i + 1, label: this._getVersionLabel(entry, detail), entry,
    }));

    const safeCurrentTime  = isFinite(currentTime) ? currentTime : 0;
    const safeDurationA    = isFinite(durationA) && durationA > 0 ? durationA : 0;
    const safeDurationB    = isFinite(durationB) && durationB > 0 ? durationB : 0;
    const progressPercentA = safeDurationA > 0 ? (safeCurrentTime / safeDurationA) * 100 : 0;
    const progressPercentB = safeDurationB > 0 ? (Math.min(safeCurrentTime, safeDurationB) / safeDurationB) * 100 : 0;
    const previewPct       = previewDuration > 0 ? (previewTime / previewDuration) * 100 : 0;

    const COLORS = ['#ff4081','#ff9100','#00e676','#2979ff','#e040fb','#ffffff'];

    let textPopupStyle = { left: 0, top: 0 };
    if (showTextInput && pendingTextPos) {
      const canvas = this.overlayCanvasRef.current;
      const W = canvas ? canvas.clientWidth : 400;
      const H = canvas ? canvas.clientHeight : 300;
      const px = pendingTextPos.x * W, py = pendingTextPos.y * H;
      textPopupStyle = { left: Math.min(px, W - 240), top: py + 12 > H - 60 ? py - 52 : py + 12 };
    }

    const timelineIcons = safeDurationA > 0
      ? allComments.map(c => ({ ...c, pct: Math.min(100, Math.max(0, ((c.timeSec || 0) / safeDurationA) * 100)) }))
      : [];

    const previewComments = [...allComments].sort((a, b) => (a.timeSec || 0) - (b.timeSec || 0));

    const oldComments      = this._getCommentsFromEntry(entryB);
    const oldTimelineIcons = safeDurationB > 0
      ? oldComments.map(c => ({ ...c, pct: Math.min(100, Math.max(0, ((c.timeSec || 0) / safeDurationB) * 100)) }))
      : [];

    // 旧版修正指示（時間順ソート）
    const sortedOldComments = [...oldComments].sort((a, b) => (a.timeSec || 0) - (b.timeSec || 0));

    // ★ 旧バージョンサイドバーを表示するか: 前バージョンが存在 かつ showOldTimeline が ON
    const hasOldVersion    = historyList.length >= 2 && entryB;
    const showOldSidebar   = hasOldVersion && showOldTimeline;

    const SORT_LABELS = { [SORT_TIME]: '再生時間順', [SORT_NEW]: '新しい順', [SORT_OLD]: '古い順' };
    const SORT_CYCLES = { [SORT_TIME]: SORT_NEW, [SORT_NEW]: SORT_OLD, [SORT_OLD]: SORT_TIME };

    const canSubmit         = !isSaving && (commentText.trim().length > 0 || annotations.length > 0);
    const toolsDisabled     = isPlaying;
    const toolDisabledTitle = '再生中は描画できません。一時停止してから操作してください。';

    // ★ 現在の再生位置に対応する旧版コメントかどうか判定（ANNOTATION_DISPLAY_DURATION 範囲内）
    const isOldCommentActive = (comment) => {
      const t = comment.timeSec || 0;
      return safeCurrentTime >= t && safeCurrentTime <= t + ANNOTATION_DISPLAY_DURATION;
    };

    return (
      <div className="vim-overlay">
        <style dangerouslySetInnerHTML={{ __html: `
          .vim-overlay {
            position:fixed; top:0; left:0; width:100%; height:100%;
            background:rgba(0,0,0,.5);
            display:flex; align-items:center; justify-content:center;
            z-index:1000;
            font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;
            box-sizing:border-box;
          }
          .vim-overlay * { box-sizing:border-box; }
          .vim-modal {
            background:#fff; width:95%; max-width:1400px; height:90vh;
            border-radius:8px; display:flex; flex-direction:column;
            overflow:hidden; box-shadow:0 4px 20px rgba(0,0,0,.15);
          }
          .vim-body { display:flex; flex:1; overflow:hidden; }
          .vim-main {
            flex:1; padding:16px; overflow-y:auto;
            display:flex; flex-direction:column; background:#fcfdfe;
          }
          .vim-video-row { display:flex; gap:16px; flex:1; min-height:0; margin-bottom:12px; }
          .vim-vwrap {
            flex:1; background:#fff; border:1px solid #e1e8ed;
            border-radius:6px; overflow:hidden; display:flex; flex-direction:column;
          }
          .vim-titlebar {
            height:39px; padding:0 12px;
            background:#fafbfc; border-bottom:1px solid #e1e8ed;
            font-size:11px; color:#666;
            display:flex; gap:6px; align-items:center;
            flex-wrap:nowrap; overflow:hidden; flex-shrink:0;
          }
          .vim-badge-blue { color:#0066ff; font-weight:bold; white-space:nowrap; }
          .vim-vbox {
            position:relative; background:#1a1e21;
            flex:1; min-height:0;
            display:flex; align-items:center; justify-content:center;
          }
          .vim-vbox video { width:100%; height:100%; object-fit:contain; pointer-events:none; }
          .vim-ver-select {
            font-size:10px; color:#555; border:1px solid #d0d7de;
            border-radius:3px; padding:1px 4px; background:#fff; cursor:pointer;
            max-width:80px; flex-shrink:0;
          }
          .vim-canvas {
            position:absolute; top:0; left:0; width:100%; height:100%;
            z-index:20; pointer-events:none;
          }
          .vim-canvas.active    { pointer-events:all; cursor:crosshair; }
          .vim-canvas.textmode  { pointer-events:all; cursor:text; }
          .vim-canvas.selectmode{ pointer-events:all; cursor:move; }
          .vim-canvas.disabled  { pointer-events:all; cursor:not-allowed; }
          .vim-toolbar { display:flex; align-items:center; gap:4px; flex:1; overflow:hidden; }
          .vim-tbtn {
            width:26px; height:26px; border-radius:4px;
            border:1px solid #d0d7de; background:#fff;
            font-size:13px; cursor:pointer;
            display:flex; align-items:center; justify-content:center;
            transition:all .15s; color:#444; flex-shrink:0;
          }
          .vim-tbtn:hover:not(.disabled-tool) { border-color:#0066ff; color:#0066ff; background:#f0f5ff; }
          .vim-tbtn.on  { border-color:#0066ff; background:#0066ff; color:#fff; box-shadow:0 1px 4px rgba(0,102,255,.3); }
          .vim-tbtn.del:hover { border-color:#e53935; color:#e53935; background:#fff5f5; }
          .vim-tbtn.disabled-tool { opacity:0.38; cursor:not-allowed !important; }
          .vim-cdot {
            width:16px; height:16px; border-radius:50%;
            border:2px solid #fff; cursor:pointer; flex-shrink:0;
            box-shadow:0 0 0 1px rgba(0,0,0,.15); transition:transform .1s;
          }
          .vim-cdot:hover { transform:scale(1.2); }
          .vim-cdot.on { box-shadow:0 0 0 2px #0066ff; transform:scale(1.15); }
          .vim-cdot.disabled-tool { opacity:0.38; cursor:not-allowed !important; }
          .vim-sep { width:1px; height:16px; background:#e0e0e0; margin:0 2px; flex-shrink:0; }
          .vim-acnt { font-size:10px; color:#888; white-space:nowrap; }
          .vim-text-cursor-preview {
            position:absolute;
            border:2px dashed rgba(255,255,255,0.7);
            border-radius:3px; padding:3px 8px;
            pointer-events:none; z-index:25;
            white-space:nowrap; font-size:13px; font-weight:bold;
            color:rgba(255,255,255,0.5); background:rgba(0,0,0,0.25);
            transform:translate(4px, -50%);
          }
          .vim-text-cursor-anchor {
            border-color:rgba(255,255,255,0.9);
            color:rgba(255,255,255,0.85);
            background:rgba(0,102,255,0.25);
            animation: vim-anchor-pulse 1s ease-in-out infinite;
          }
          @keyframes vim-anchor-pulse { 0%,100% { opacity:1; } 50% { opacity:0.5; } }
          .vim-textpop {
            position:absolute; z-index:30; background:#fff;
            border:1.5px solid #0066ff; border-radius:6px;
            padding:8px; box-shadow:0 4px 14px rgba(0,0,0,.18);
            display:flex; gap:6px; align-items:center; min-width:220px;
            pointer-events:all;
          }
          .vim-textpop-input {
            flex:1; border:1px solid #d0d7de; border-radius:4px;
            padding:4px 8px; font-size:13px; outline:none;
          }
          .vim-textpop-input:focus { border-color:#0066ff; }
          .vim-textpop-ok  { background:#0066ff; color:#fff; border:none; border-radius:4px; padding:4px 10px; font-size:12px; cursor:pointer; }
          .vim-textpop-can { background:none; color:#888; border:1px solid #d0d7de; border-radius:4px; padding:4px 8px; font-size:12px; cursor:pointer; }
          .vim-ctrlbar {
            position:absolute; bottom:0; left:0; width:100%;
            background:rgba(27,38,49,.9);
            display:flex; align-items:center; padding:6px 12px;
            color:#fff; font-size:11px; gap:12px; z-index:10;
            opacity:0; visibility:hidden; transition:opacity .2s,visibility .2s;
          }
          .vim-vbox:hover .vim-ctrlbar { opacity:1; visibility:visible; }
          .vim-playbtn {
            background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.5);
            border-radius:50%; cursor:pointer; color:#fff; padding:0;
            display:flex; align-items:center; justify-content:center;
            width:28px; height:28px; transition:background .15s,border-color .15s; flex-shrink:0;
          }
          .vim-playbtn:hover { background:rgba(255,255,255,.28); border-color:#fff; }
          .play-icon  { width:0; height:0; border-top:6px solid transparent; border-bottom:6px solid transparent; border-left:10px solid #fff; margin-left:2px; }
          .pause-icon { display:flex; gap:3px; align-items:center; justify-content:center; width:14px; height:14px; }
          .pause-bar  { width:3px; height:11px; background:#fff; border-radius:1px; }
          .vim-prog {
            flex:1; height:4px; background:rgba(255,255,255,.3);
            position:relative; border-radius:2px; cursor:pointer;
          }
          .vim-prog-fill { height:100%; background:#0066ff; border-radius:2px; }
          .vim-prog-ball { position:absolute; top:-3px; width:10px; height:10px; background:#fff; border-radius:50%; transform:translateX(-50%); }
          .vim-timeline {
            background:#fff; border:1px solid #e1e8ed; border-radius:6px;
            padding:6px 12px; margin-bottom:12px;
            display:flex; align-items:center; gap:12px;
          }
          .vim-bigbtn {
            width:34px; height:34px; border-radius:50%;
            border:1.5px solid #0066ff; background:#fff;
            cursor:pointer; display:flex; align-items:center; justify-content:center;
            transition:all .2s; box-shadow:0 1px 3px rgba(0,102,255,.1); flex-shrink:0;
          }
          .vim-bigbtn:hover { background:#0066ff; }
          .vim-bigbtn:hover .lplay { border-left-color:#fff; }
          .vim-bigbtn:hover .lpause-bar { background:#fff; }
          .lplay  { width:0; height:0; border-top:7px solid transparent; border-bottom:7px solid transparent; border-left:11px solid #0066ff; margin-left:3px; }
          .lpause { display:flex; gap:4px; align-items:center; }
          .lpause-bar { width:3px; height:12px; background:#0066ff; border-radius:1px; }
          .vim-tlblock { flex:1; display:flex; flex-direction:column; }
          .vim-tltime  { font-size:11px; font-weight:bold; color:#333; margin-bottom:2px; font-variant-numeric:tabular-nums; }
          .vim-tlaxis  { height:4px; background:#e1e8ed; position:relative; margin:2px 0; border-radius:2px; cursor:pointer; }
          .vim-tlaxis-fill { height:100%; background:#0066ff; border-radius:2px; opacity:.15; }
          .vim-tllabels { display:flex; justify-content:space-between; font-size:9px; color:#999; margin-bottom:3px; }
          .vim-tlpin { position:absolute; top:-4px; width:12px; height:12px; background:#ff4081; border:2px solid #fff; border-radius:50%; transform:translateX(-50%); box-shadow:0 1px 3px rgba(0,0,0,.3); z-index:5; }
          .vim-icons-row { position:relative; height:16px; margin-top:2px; }
          .vim-tic {
            position:absolute; top:0; width:14px; height:14px; border-radius:50%;
            border:1.5px solid #fff; box-shadow:0 1px 3px rgba(0,0,0,.25);
            transform:translateX(-50%); cursor:pointer; overflow:hidden;
            display:flex; align-items:center; justify-content:center;
            font-size:7px; color:#fff; font-weight:bold;
          }
          .vim-tic img { width:100%; height:100%; object-fit:cover; border-radius:50%; display:block; }
          .vim-old-tl-btn {
            background:none; border:1px solid #d0d7de; border-radius:3px;
            font-size:9px; color:#555; cursor:pointer; padding:2px 6px;
            transition:all .15s; flex-shrink:0; margin-left:auto;
          }
          .vim-old-tl-btn:hover { border-color:#0066ff; color:#0066ff; }
          .vim-old-tl-btn.on { border-color:#0066ff; background:#0066ff; color:#fff; }
          .vim-tl-label { font-size:9px; font-weight:bold; padding:0 4px 2px 0; white-space:nowrap; flex-shrink:0; }
          .vim-tl-label-a { color:#0066ff; }
          .vim-tl-label-b { color:#888; }
          .vim-old-tl-row { margin-top:6px; padding-top:6px; border-top:1px dashed #e1e8ed; }
          .vim-old-tlaxis { height:4px; background:#e1e8ed; position:relative; margin:2px 0; border-radius:2px; cursor:pointer; }
          .vim-old-tlaxis-fill { height:100%; background:#999; border-radius:2px; opacity:.2; }
          .vim-old-tllabels { display:flex; justify-content:space-between; font-size:9px; color:#bbb; margin-bottom:3px; }
          .vim-old-icons-row { position:relative; height:16px; margin-top:2px; z-index:10; }
          .vim-old-tic {
            position:absolute; top:0; width:14px; height:14px; border-radius:50%;
            border:1.5px solid #fff; box-shadow:0 1px 3px rgba(0,0,0,.2);
            transform:translateX(-50%);
            display:flex; align-items:center; justify-content:center;
            font-size:7px; color:#fff; font-weight:bold; overflow:hidden;
          }
          .vim-old-tic img { width:100%; height:100%; object-fit:cover; border-radius:50%; display:block; }

          /* vim-tip: アイコンの上に表示・横幅2倍 */
          .vim-tic-wrap, .vim-old-tic-wrap {
            position:absolute; top:0; transform:translateX(-50%);
          }
          .vim-tic-wrap .vim-tip, .vim-old-tic-wrap .vim-tip {
            display:none;
            position:absolute;
            /* アイコン(14px)の上端からさらに上へ: bottom = アイコン高さ + 余白 */
            bottom:calc(14px + 8px);
            /* 中央揃えだとはみ出すことがあるので左端基準に補正 */
            left:50%; transform:translateX(-50%);
            background:rgba(30,34,40,.93);
            color:#fff; font-size:10px; line-height:1.5;
            padding:7px 12px; border-radius:5px;
            box-shadow:0 2px 10px rgba(0,0,0,.35);
            pointer-events:none; z-index:200;
            min-width:320px; max-width:600px;
            white-space:normal; word-break:break-all;
          }
          .vim-tic-wrap .vim-tip::after, .vim-old-tic-wrap .vim-tip::after {
            content:''; position:absolute;
            top:100%; left:50%; transform:translateX(-50%);
            border:5px solid transparent; border-top-color:rgba(30,34,40,.93);
          }
          .vim-tic-wrap:hover .vim-tip, .vim-old-tic-wrap:hover .vim-tip { display:block; }

          .vim-form {
            background:#fff; border:1px solid #b3c0d1; border-radius:6px;
            display:flex; flex-direction:column; padding:12px;
            box-shadow:0 2px 10px rgba(0,0,0,.05);
          }
          .vim-form textarea {
            width:100%; border:1px solid #dcdfe6; border-radius:4px;
            resize:none; padding:10px; font-size:13px; outline:none;
            height:54px; min-height:54px; color:#333; line-height:1.5;
            background:#f8fafc; transition:border-color .2s,background .2s;
          }
          .vim-form textarea:focus { background:#fff; border-color:#0066ff; }
          .vim-form-footer { display:flex; justify-content:space-between; align-items:center; margin-top:8px; }
          .vim-timelabel {
            font-size:11px; font-weight:bold; color:#ff4081;
            display:flex; align-items:center; gap:4px;
            background:#fff0f5; padding:4px 10px; border-radius:4px; border:1px solid #ffd1dc;
          }
          .vim-addbtn {
            background:#0066ff; color:#fff; border:none;
            padding:6px 20px; font-size:12px; border-radius:4px;
            cursor:pointer; font-weight:bold;
            box-shadow:0 2px 4px rgba(0,102,255,.15); transition:background .2s;
          }
          .vim-addbtn:hover { background:#0052cc; }
          .vim-addbtn:disabled { background:#aac4ff; cursor:not-allowed; }
          .vim-cancelbtn {
            background:#fff; color:#666; border:1px solid #d0d7de;
            padding:6px 12px; font-size:12px; border-radius:4px;
            cursor:pointer; transition:background .15s;
          }
          .vim-cancelbtn:hover { background:#f5f5f5; }
          .vim-form-editing { border-color:#ff9100; box-shadow:0 2px 10px rgba(255,145,0,.15); }
          .vim-edit-banner {
            font-size:11px; font-weight:bold; color:#ff6d00;
            background:#fff8ee; border:1px solid #ffe0b2;
            border-radius:4px; padding:5px 10px; margin-bottom:6px; text-align:center;
          }
          .vim-editbtn {
            display:inline-block; margin-top:5px;
            background:none; border:1px solid #d0d7de; border-radius:3px;
            font-size:9px; color:#666; cursor:pointer; padding:2px 7px; transition:all .15s;
          }
          .vim-editbtn:hover { border-color:#ff9100; color:#ff6d00; background:#fff8ee; }
          .vim-editbtn.on { border-color:#ff9100; background:#ff9100; color:#fff; }
          .vim-card-active { background:#fffaf0 !important; border-left:3px solid #ff9100; }

          /* サイドバーラッパー */
          .vim-sidebar-wrapper {
            display:flex; flex-direction:row;
            border-left:1px solid #eef2f5;
            background:#fff; margin-top:18px; overflow:hidden;
          }

          /* 現行版サイドバー */
          .vim-sidebar {
            width:230px; min-width:200px;
            display:flex; flex-direction:column;
            border-right:1px solid #eef2f5;
          }
          .vim-sidebar-hdr {
            padding:6px 12px; border-bottom:1px solid #f5f7fa;
            display:flex; justify-content:space-between; align-items:center;
            font-size:10px; color:#666; background:#fafbfc; flex-shrink:0;
          }
          .vim-sort-btn { background:none; border:1px solid #d0d7de; border-radius:3px; font-size:9px; color:#555; cursor:pointer; padding:2px 5px; transition:all .15s; }
          .vim-sort-btn:hover { border-color:#0066ff; color:#0066ff; }
          .vim-clist { flex:1; overflow-y:auto; padding:0 10px; }
          .vim-card {
            padding:10px 0; border-bottom:1px solid #f0f2f5; position:relative;
            cursor:pointer; border-radius:4px; transition:background .15s;
          }
          .vim-card:hover { background:#f5f8ff; }
          .vim-card-meta { display:flex; align-items:center; gap:4px; margin-bottom:4px; }
          .vim-badge { color:#fff; font-size:9px; font-weight:bold; width:14px; height:14px; border-radius:2px; flex-shrink:0; display:flex; align-items:center; justify-content:center; }
          .vim-timetag  { color:#0066ff; font-size:11px; font-weight:bold; }
          .vim-userrow  { display:flex; align-items:center; gap:6px; margin-bottom:4px; }
          .vim-avatar   { width:18px; height:18px; border-radius:50%; object-fit:cover; flex-shrink:0; }
          .vim-uname    { font-size:11px; font-weight:bold; color:#333; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:80px; }
          .vim-date     { font-size:9px; color:#999; margin-left:auto; }
          .vim-ctext    { font-size:11px; color:#444; line-height:1.4; margin:0 0 4px; }
          .vim-anncnt   { font-size:9px; color:#aaa; }
          .vim-delbtn   { position:absolute; top:8px; right:0; background:none; border:none; color:#ccc; font-size:15px; cursor:pointer; line-height:1; padding:0 2px; }
          .vim-delbtn:hover { color:#e53935; }
          .vim-empty    { font-size:11px; color:#bbb; text-align:center; margin-top:20px; }

          /* ★ 旧バージョンサイドバー — 落ち着いたグレートーン */
          .vim-old-sidebar {
            width:230px; min-width:200px;
            display:flex; flex-direction:column;
            background:#f9f9f9;
            border-left:1px solid #e8e8e8;
          }
          .vim-old-sidebar-hdr {
            padding:6px 12px; border-bottom:1px solid #e4e4e4;
            display:flex; justify-content:space-between; align-items:center;
            font-size:10px; background:#f2f2f2; flex-shrink:0;
          }
          .vim-old-sidebar-hdr-title {
            font-weight:bold; color:#555; display:flex; align-items:center; gap:4px;
          }
          .vim-old-sidebar-ver {
            font-weight:normal; color:#888; margin-left:4px;
          }
          .vim-old-clist { flex:1; overflow-y:auto; padding:0 10px; }
          .vim-old-card {
            padding:10px 0; border-bottom:1px solid #ebebeb; position:relative;
            cursor:pointer; border-radius:4px; transition:background .15s;
          }
          .vim-old-card:hover { background:#f0f0f0; }

          /* ★ 旧版コメントのアクティブ（現在時刻にヒット）ハイライト — 控えめ */
          .vim-old-card-active {
            background:#efefef !important;
            border-left:2px solid #aaa;
            border-radius:0px;
            margin-left:-10px;
            padding-left:10px;
          }

          .vim-old-card-meta { display:flex; align-items:center; gap:4px; margin-bottom:4px; }
          .vim-old-badge {
            color:#fff; font-size:9px; font-weight:bold; width:14px; height:14px;
            border-radius:2px; flex-shrink:0; display:flex; align-items:center; justify-content:center;
            background:#999;
          }
          .vim-old-timetag { color:#666; font-size:11px; font-weight:bold; }
          .vim-old-userrow { display:flex; align-items:center; gap:6px; margin-bottom:4px; }
          .vim-old-uname { font-size:11px; font-weight:bold; color:#555; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:100px; }
          .vim-old-date  { font-size:9px; color:#aaa; margin-left:auto; }
          .vim-old-ctext { font-size:11px; color:#666; line-height:1.4; margin:0 0 4px; }
          .vim-old-anncnt{ font-size:9px; color:#aaa; }
          .vim-old-empty { font-size:11px; color:#bbb; text-align:center; margin-top:20px; }

          .vim-footer {
            padding:10px 24px; border-top:1px solid #eef2f5;
            display:flex; justify-content:flex-end; align-items:center;
            gap:10px; background:#fff;
          }
          .vim-saving  { font-size:11px; color:#999; margin-right:auto; }
          .vim-prevbtn { background:#fff; color:#0066ff; border:1.5px solid #0066ff; padding:6px 16px; font-size:12px; border-radius:4px; cursor:pointer; font-weight:bold; transition:background .2s,color .2s; }
          .vim-prevbtn:hover { background:#0066ff; color:#fff; }
          .vim-closebtn{ background:#0066ff; color:#fff; border:none; padding:6px 18px; font-size:12px; border-radius:4px; cursor:pointer; }

          .vim-preview-overlay { position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,.65); display:flex; align-items:center; justify-content:center; z-index:2000; }
          .vim-preview-modal { background:#1a1e21; width:92%; max-width:900px; height:88vh; border-radius:10px; display:flex; flex-direction:column; overflow:hidden; box-shadow:0 8px 40px rgba(0,0,0,.5); color:#fff; }
          .vim-preview-hdr { padding:10px 16px; background:#111517; display:flex; align-items:center; justify-content:space-between; border-bottom:1px solid #2a2e32; flex-shrink:0; }
          .vim-preview-hdr h3 { margin:0; font-size:14px; color:#fff; }
          .vim-preview-close { background:none; border:none; color:#aaa; font-size:20px; cursor:pointer; line-height:1; padding:0; }
          .vim-preview-close:hover { color:#fff; }
          .vim-preview-body { display:flex; flex:1; overflow:hidden; }
          .vim-preview-video-col { flex:1; display:flex; flex-direction:column; border-right:1px solid #2a2e32; }
          .vim-preview-vbox { position:relative; flex:1; min-height:0; background:#000; display:flex; align-items:center; justify-content:center; }
          .vim-preview-vbox video { width:100%; height:100%; object-fit:contain; pointer-events:none; }
          .vim-preview-canvas { position:absolute; top:0; left:0; width:100%; height:100%; z-index:10; pointer-events:none; }
          .vim-preview-ctrl { padding:8px 14px; background:#111517; display:flex; align-items:center; gap:10px; border-top:1px solid #2a2e32; flex-shrink:0; }
          .vim-preview-playbtn { background:rgba(255,255,255,.1); border:1.5px solid rgba(255,255,255,.4); border-radius:50%; cursor:pointer; color:#fff; padding:0; display:flex; align-items:center; justify-content:center; width:30px; height:30px; flex-shrink:0; transition:background .15s; }
          .vim-preview-playbtn:hover { background:rgba(255,255,255,.25); }
          .vim-preview-prog { flex:1; height:4px; background:rgba(255,255,255,.2); position:relative; border-radius:2px; cursor:pointer; }
          .vim-preview-prog-fill { height:100%; background:#0066ff; border-radius:2px; }
          .vim-preview-prog-ball { position:absolute; top:-3px; width:10px; height:10px; background:#fff; border-radius:50%; transform:translateX(-50%); }
          .vim-preview-timedisp { font-size:11px; color:#ccc; font-variant-numeric:tabular-nums; white-space:nowrap; }
          .vim-preview-comments-col { width:260px; display:flex; flex-direction:column; background:#111517; overflow:hidden; }
          .vim-preview-comments-hdr { padding:10px 14px; font-size:12px; font-weight:bold; color:#aaa; border-bottom:1px solid #2a2e32; flex-shrink:0; }
          .vim-preview-clist { flex:1; overflow-y:auto; padding:0 12px; }
          .vim-preview-citem { padding:10px 0; border-bottom:1px solid #222629; cursor:pointer; }
          .vim-preview-citem:hover { background:rgba(255,255,255,.03); }
          .vim-preview-ctimecode { font-size:11px; font-weight:bold; color:#0088ff; margin-bottom:4px; }
          .vim-preview-cuserrow { display:flex; align-items:center; gap:6px; margin-bottom:4px; }
          .vim-preview-cavatar { width:18px; height:18px; border-radius:50%; object-fit:cover; }
          .vim-preview-cname { font-size:11px; font-weight:bold; color:#ddd; }
          .vim-preview-ctext { font-size:11px; color:#bbb; line-height:1.4; margin:0; }
        ` }} />

        <div className="vim-modal">
          <div className="vim-body">

            {/* メイン */}
            <div className="vim-main">

              {/* 動画行 */}
              <div className="vim-video-row">

                {/* 動画A（修正版） */}
                <div className="vim-vwrap">
                  <div className="vim-titlebar">
                    <span className="vim-badge-blue">A（修正版） {videoA_ver}</span>
                    <div className="vim-toolbar">
                      <div className="vim-sep" />
                      <button type="button"
                        className={`vim-tbtn${drawingTool==='circle'?' on':''}${toolsDisabled?' disabled-tool':''}`}
                        title={toolsDisabled ? toolDisabledTitle : '丸を描く'}
                        onClick={() => !toolsDisabled && this.setDrawingTool('circle')}>○</button>
                      <button type="button"
                        className={`vim-tbtn${drawingTool==='arrow'?' on':''}${toolsDisabled?' disabled-tool':''}`}
                        title={toolsDisabled ? toolDisabledTitle : '矢印を描く'}
                        onClick={() => !toolsDisabled && this.setDrawingTool('arrow')}>↗</button>
                      <button type="button"
                        className={`vim-tbtn${drawingTool==='text'?' on':''}${toolsDisabled?' disabled-tool':''}`}
                        title={toolsDisabled ? toolDisabledTitle : 'テキストを追加'}
                        onClick={() => !toolsDisabled && this.setDrawingTool('text')}>T</button>
                      <div className="vim-sep" />
                      {COLORS.map(c => (
                        <div key={c}
                          className={`vim-cdot${annotationColor===c?' on':''}${toolsDisabled?' disabled-tool':''}`}
                          style={{ background: c }}
                          title={toolsDisabled ? toolDisabledTitle : c}
                          onClick={() => !toolsDisabled && this.setState({ annotationColor: c })} />
                      ))}
                      <div className="vim-sep" />
                      <button type="button"
                        className={`vim-tbtn del${toolsDisabled?' disabled-tool':''}`}
                        title={toolsDisabled ? toolDisabledTitle : '描き込みをクリア'}
                        onClick={() => !toolsDisabled && this.clearAnnotations()}>🗑</button>
                      {annotations.length > 0 && <span className="vim-acnt">{annotations.length}件</span>}
                    </div>
                  </div>
                  <div className="vim-vbox">
                    <video ref={this.videoARef} src={videoA_src}
                      onTimeUpdate={this.handleTimeUpdate.bind(this)}
                      onLoadedMetadata={this.handleLoadedMetadata.bind(this)}
                      onEnded={this.handleVideoEnded.bind(this)} />
                    <canvas
                      ref={this.overlayCanvasRef}
                      className={
                        'vim-canvas' +
                        (toolsDisabled
                          ? (drawingTool ? ' disabled' : '')
                          : drawingTool === 'text' ? ' textmode'
                          : drawingTool ? ' active'
                          : annotations.length > 0 ? ' selectmode' : '')
                      }
                      onMouseDown={e => !toolsDisabled && this._drawingHandler('mousedown', e)}
                      onMouseMove={e => { if (!toolsDisabled) this._drawingHandler('mousemove', e); }}
                      onMouseUp={e => !toolsDisabled && this._drawingHandler('mouseup', e)}
                      onMouseLeave={e => { if (drawingTool === 'text') this._drawingHandler('mouseleave', e); }}
                    />
                    {drawingTool === 'text' && !showTextInput && textCursorPos && (
                      <div className="vim-text-cursor-preview" style={{ left: textCursorPos.x, top: textCursorPos.y }}>テキストを入力…</div>
                    )}
                    {drawingTool === 'text' && showTextInput && pendingTextPos && (() => {
                      const canvas = this.overlayCanvasRef.current;
                      const W = canvas ? canvas.clientWidth : 400;
                      const H = canvas ? canvas.clientHeight : 300;
                      return (
                        <div className="vim-text-cursor-preview vim-text-cursor-anchor"
                          style={{ left: pendingTextPos.x * W, top: pendingTextPos.y * H }}>
                          {textInput || 'テキストを入力…'}
                        </div>
                      );
                    })()}
                    {showTextInput && pendingTextPos && (
                      <div className="vim-textpop" style={textPopupStyle} onMouseDown={e => e.stopPropagation()}>
                        <input className="vim-textpop-input" placeholder="テキストを入力..."
                          value={textInput}
                          onChange={e => this.setState({ textInput: e.target.value })}
                          onKeyDown={e => {
                            if (e.key === 'Enter')  this.commitTextAnnotation();
                            if (e.key === 'Escape') this.setState({ showTextInput: false, pendingTextPos: null, textInput: '', textCursorPos: null });
                          }} />
                        <button type="button" className="vim-textpop-ok"
                          onClick={() => { this.commitTextAnnotation(); this.setState({ textCursorPos: null }); }}>OK</button>
                        <button type="button" className="vim-textpop-can"
                          onClick={() => this.setState({ showTextInput: false, pendingTextPos: null, textInput: '', textCursorPos: null })}>✕</button>
                      </div>
                    )}
                    <div className="vim-ctrlbar">
                      <button type="button" className="vim-playbtn" onClick={this.togglePlay.bind(this)}>
                        {isPlaying ? <div className="pause-icon"><div className="pause-bar"/><div className="pause-bar"/></div> : <div className="play-icon"/>}
                      </button>
                      <span>{this.formatTime(safeCurrentTime)} / {this.formatTime(safeDurationA)}</span>
                      <div className="vim-prog" onClick={this.handleSeek.bind(this)}>
                        <div className="vim-prog-fill" style={{ width:`${progressPercentA}%` }} />
                        <div className="vim-prog-ball" style={{ left:`${progressPercentA}%` }} />
                      </div>
                      <span>🔊 1x ⛶</span>
                    </div>
                  </div>
                </div>

                {/* 動画B（旧バージョン） */}
                {historyList.length >= 2 && (
                <div className="vim-vwrap">
                  <div className="vim-titlebar">
                    <span>B（旧版）</span>
                    {oldVersionOptions.length > 0 ? (
                      <select className="vim-ver-select" value={selectedOldIdx}
                        onChange={e => { const idx = parseInt(e.target.value, 10); this.setState({ selectedOldIdx: idx, durationB: 0 }); }}>
                        {oldVersionOptions.map(opt => (
                          <option key={opt.idx} value={opt.idx}>{opt.label}</option>
                        ))}
                      </select>
                    ) : (
                      <span style={{ fontSize:10, color:'#aaa' }}>{videoB_ver}</span>
                    )}
                    {entryB && entryB.revise_movie_option && (
                      <span style={{ fontSize:9, color:'#0066ff', background:'#f0f5ff', padding:'1px 5px', borderRadius:3, border:'1px solid #cde', flexShrink:0 }}>
                        🖊 描画あり
                      </span>
                    )}
                    {entryB && (
                      <button type="button"
                        className={`vim-old-tl-btn${showOldTimeline ? ' on' : ''}`}
                        onClick={() => this.setState({ showOldTimeline: !showOldTimeline })}>
                        {showOldTimeline ? 'TL 非表示' : 'タイムライン表示'}
                      </button>
                    )}
                  </div>
                  <div className="vim-vbox">
                    <video key={videoB_src} ref={this.videoBRef} src={videoB_src}
                      onLoadedMetadata={this.handleLoadedMetadata.bind(this)} />
                    <canvas ref={this.overlayCavnasB} className="vim-canvas" style={{ pointerEvents:'none' }} />
                    <div className="vim-ctrlbar">
                      <button type="button" className="vim-playbtn" onClick={this.togglePlay.bind(this)}>
                        {isPlaying ? <div className="pause-icon"><div className="pause-bar"/><div className="pause-bar"/></div> : <div className="play-icon"/>}
                      </button>
                      <span>{this.formatTime(Math.min(safeCurrentTime, safeDurationB))} / {this.formatTime(safeDurationB)}</span>
                      <div className="vim-prog" onClick={this.handleSeek.bind(this)}>
                        <div className="vim-prog-fill" style={{ width:`${progressPercentB}%` }} />
                        <div className="vim-prog-ball" style={{ left:`${progressPercentB}%` }} />
                      </div>
                      <span>🔊 1x ⛶</span>
                    </div>
                  </div>
                </div>
                )}
              </div>

              {/* タイムライン */}
              <div className="vim-timeline">
                <button type="button" className="vim-bigbtn" onClick={this.togglePlay.bind(this)} title={isPlaying?'一時停止':'再生'}>
                  {isPlaying ? <div className="lpause"><div className="lpause-bar"/><div className="lpause-bar"/></div> : <div className="lplay"/>}
                </button>
                <div className="vim-tlblock">
                  {/* A タイムライン */}
                  <div style={{ display:'flex', alignItems:'center', gap:4, marginBottom:1 }}>
                    <span className="vim-tl-label vim-tl-label-a">A（修正版）</span>
                    <div className="vim-tltime">{this.formatTime(safeCurrentTime)}</div>
                  </div>
                  <div className="vim-tlaxis" ref={this.timelineRef} onClick={this.handleSeek.bind(this)}>
                    <div className="vim-tlaxis-fill" style={{ width:`${progressPercentA}%` }} />
                    <div className="vim-tlpin" style={{ left:`${progressPercentA}%` }} />
                  </div>
                  <div className="vim-tllabels">
                    <span>{this.formatTime(0)}</span>
                    <span>{this.formatTime(safeDurationA * 0.25)}</span>
                    <span>{this.formatTime(safeDurationA * 0.5)}</span>
                    <span>{this.formatTime(safeDurationA * 0.75)}</span>
                    <span>{this.formatTime(safeDurationA)}</span>
                  </div>
                  <div className="vim-icons-row">
                    {timelineIcons.map((c, idx) => (
                      <div key={c.id || idx} className="vim-tic-wrap" style={{ left:`${c.pct}%` }}
                        onClick={() => this.handleIconSeek(c.timeSec)}>
                        <div className="vim-tic" style={{ backgroundColor: c.badgeColor || '#888', position:'relative', transform:'none', left:'auto', top:'auto' }}>
                          {c.avatar ? <img src={c.avatar} alt={c.author} /> : (c.author||'?').charAt(0)}
                        </div>
                        <div className="vim-tip">{c.content || '（描画のみ）'}</div>
                      </div>
                    ))}
                  </div>

                  {/* B タイムライン（showOldTimeline ON の場合のみ） */}
                  {historyList.length >= 2 && showOldTimeline && entryB && (
                    <div className="vim-old-tl-row">
                      <div style={{ display:'flex', alignItems:'center', gap:4, marginBottom:1 }}>
                        <span className="vim-tl-label vim-tl-label-b">B（{videoB_ver}）</span>
                        <span style={{ fontSize:9, color:'#bbb', fontVariantNumeric:'tabular-nums' }}>
                          {this.formatTime(Math.min(safeCurrentTime, safeDurationB))}
                        </span>
                      </div>
                      <div className="vim-old-tlaxis" onClick={this.handleOldSeek.bind(this)}>
                        <div className="vim-old-tlaxis-fill"
                          style={{ width: safeDurationB > 0 ? `${Math.min(safeCurrentTime, safeDurationB) / safeDurationB * 100}%` : '0%' }} />
                        <div style={{
                          position:'absolute', top:-4,
                          left: safeDurationB > 0 ? `${Math.min(safeCurrentTime, safeDurationB) / safeDurationB * 100}%` : '0%',
                          width:12, height:12, background:'#999',
                          border:'2px solid #fff', borderRadius:'50%',
                          transform:'translateX(-50%)',
                          boxShadow:'0 1px 3px rgba(0,0,0,.3)', zIndex:5,
                        }} />
                      </div>
                      <div className="vim-old-tllabels">
                        <span>{this.formatTime(0)}</span>
                        <span>{this.formatTime(safeDurationB * 0.25)}</span>
                        <span>{this.formatTime(safeDurationB * 0.5)}</span>
                        <span>{this.formatTime(safeDurationB * 0.75)}</span>
                        <span>{this.formatTime(safeDurationB)}</span>
                      </div>
                      {oldTimelineIcons.length > 0 && (
                        <div className="vim-old-icons-row">
                          {oldTimelineIcons.map((c, idx) => (
                            <div key={c.id || idx} className="vim-old-tic-wrap" style={{ left:`${c.pct}%` }}
                              onClick={() => this.handleIconSeek(c.timeSec)}>
                              <div className="vim-old-tic" style={{ backgroundColor: c.badgeColor || '#999', position:'relative', transform:'none', left:'auto', top:'auto' }}>
                                {c.avatar ? <img src={c.avatar} alt={c.author} /> : (c.author||'?').charAt(0)}
                              </div>
                              <div className="vim-tip">{c.content || '（描画のみ）'}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* 修正指示フォーム */}
              <div className={`vim-form${editingCommentId ? ' vim-form-editing' : ''}`}>
                {editingCommentId && (
                  <div className="vim-edit-banner">✏️ 修正指示を編集中 — 描画をドラッグして位置を変更できます</div>
                )}
                <textarea placeholder="修正指示を入力..."
                  value={commentText} onChange={this.handleCommentChange.bind(this)} />
                <div className="vim-form-footer">
                  <div className="vim-timelabel">
                    <span>⏱ {this.formatTime(safeCurrentTime)}</span>
                    {editingCommentId ? ' の修正指示を編集' : ' に修正指示を追加'}
                  </div>
                  {editingCommentId ? (
                    <div style={{ display:'flex', gap:6 }}>
                      <button type="button" className="vim-cancelbtn" onClick={() => this.handleCancelEdit()}>キャンセル</button>
                      <button type="button" className="vim-addbtn" onClick={() => this.handleSaveEditedComment()}>保存</button>
                    </div>
                  ) : (
                    <button type="button" className="vim-addbtn"
                      onClick={this.handleAddComment.bind(this)} disabled={!canSubmit}>
                      {isSaving ? '保存中...' : '修正指示を追加'}
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* ★ サイドバーラッパー */}
            <div className="vim-sidebar-wrapper">

              {/* 現行版修正指示サイドバー */}
              <div className="vim-sidebar">
                <div className="vim-sidebar-hdr">
                  <span>修正指示 ({allComments.length})</span>
                  <button type="button" className="vim-sort-btn"
                    onClick={() => this.setState({ sortOrder: SORT_CYCLES[sortOrder] })}>
                    {SORT_LABELS[sortOrder]} ⇅
                  </button>
                </div>
                <div className="vim-clist">
                  {sortedComments.length === 0 && <p className="vim-empty">修正指示はまだありません</p>}
                  {sortedComments.map((comment, idx) => {
                    const isEditing = editingCommentId === comment.id;
                    return (
                      <div className={`vim-card${isEditing ? ' vim-card-active' : ''}`} key={comment.id}
                        onClick={e => {
                          if (e.target.classList.contains('vim-delbtn')) return;
                          if (e.target.classList.contains('vim-editbtn')) return;
                          this.handleIconSeek(comment.timeSec);
                        }}>
                        <button type="button" className="vim-delbtn" title="削除"
                          onClick={() => this.handleDeleteComment(comment.id)}>×</button>
                        <div className="vim-card-meta">
                          <span className="vim-badge" style={{ backgroundColor: comment.badgeColor }}>{idx + 1}</span>
                          <span className="vim-timetag">⏱ {comment.timecode}</span>
                        </div>
                        <div className="vim-userrow">
                          {comment.avatar
                            ? <img src={comment.avatar} className="vim-avatar" alt="avatar" />
                            : <div style={{ width:18, height:18, borderRadius:'50%', background:'#ddd', flexShrink:0 }} />}
                          <span className="vim-uname">{comment.author}</span>
                          <span className="vim-date">{comment.date}</span>
                        </div>
                        {comment.content && <p className="vim-ctext">{comment.content}</p>}
                        {comment.annotations && comment.annotations.length > 0 && (
                          <span className="vim-anncnt">🖊 描き込み {comment.annotations.length}件</span>
                        )}
                        <button type="button"
                          className={`vim-editbtn${isEditing ? ' on' : ''}`}
                          title={isEditing ? '編集中' : '描画・テキストを編集'}
                          onClick={() => isEditing ? this.handleCancelEdit() : this.handleEditComment(comment)}>
                          {isEditing ? '編集中' : '✏️ 編集'}
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* ★ 旧バージョン修正指示サイドバー
                   showOldTimeline が ON の場合のみ表示 */}
              {showOldSidebar && (
                <div className="vim-old-sidebar">
                  <div className="vim-old-sidebar-hdr">
                    <span className="vim-old-sidebar-hdr-title">
                      旧版の修正指示
                      <span className="vim-old-sidebar-ver">（{videoB_ver}）</span>
                    </span>
                    <span style={{ color:'#999' }}>{sortedOldComments.length}件</span>
                  </div>
                  <div className="vim-old-clist">
                    {sortedOldComments.length === 0 && (
                      <p className="vim-old-empty">修正指示はありません</p>
                    )}
                    {sortedOldComments.map((comment, idx) => {
                      const isActive = isOldCommentActive(comment);
                      return (
                        <div
                          className={`vim-old-card${isActive ? ' vim-old-card-active' : ''}`}
                          key={comment.id || idx}
                          onClick={() => this.handleIconSeek(comment.timeSec)}>
                          <div className="vim-old-card-meta">
                            <span className="vim-old-badge">{idx + 1}</span>
                            <span className="vim-old-timetag">⏱ {comment.timecode || this.formatTime(comment.timeSec || 0)}</span>
                          </div>
                          <div className="vim-old-userrow">
                            {comment.avatar
                              ? <img src={comment.avatar} className="vim-avatar" alt="avatar" />
                              : <div style={{ width:18, height:18, borderRadius:'50%', background:'#ccc', flexShrink:0 }} />}
                            <span className="vim-old-uname">{comment.author}</span>
                            <span className="vim-old-date">{comment.date}</span>
                          </div>
                          {comment.content && <p className="vim-old-ctext">{comment.content}</p>}
                          {comment.annotations && comment.annotations.length > 0 && (
                            <span className="vim-old-anncnt">🖊 描き込み {comment.annotations.length}件</span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* フッター */}
          <div className="vim-footer">
            {isSaving && <span className="vim-saving">💾 保存中...</span>}
            <button type="button" className="vim-prevbtn" onClick={() => this.openPreview()}>📋 プレビュー</button>
            <button type="button" className="vim-closebtn" onClick={() => this.handleCloseWithGuard()}>閉じる</button>
          </div>
        </div>

        {/* プレビューモーダル */}
        {showPreview && (
          <div className="vim-preview-overlay" onClick={e => { if (e.target === e.currentTarget) this.closePreview(); }}>
            <div className="vim-preview-modal">
              <div className="vim-preview-hdr">
                <h3>🎬 修正版プレビュー — 修正指示一覧</h3>
                <button type="button" className="vim-preview-close" onClick={() => this.closePreview()}>✕</button>
              </div>
              <div className="vim-preview-body">
                <div className="vim-preview-video-col">
                  <div className="vim-preview-vbox">
                    <video ref={this.previewVideoRef} src={videoA_src}
                      onLoadedMetadata={this.handlePreviewMetadata.bind(this)}
                      onEnded={this.handlePreviewEnded.bind(this)} />
                    <canvas ref={this.previewCanvasRef} className="vim-preview-canvas" />
                  </div>
                  <div className="vim-preview-ctrl">
                    <button type="button" className="vim-preview-playbtn" onClick={() => this.togglePreviewPlay()}>
                      {previewPlaying ? <div className="pause-icon"><div className="pause-bar"/><div className="pause-bar"/></div> : <div className="play-icon"/>}
                    </button>
                    <div className="vim-preview-prog" onClick={this.handlePreviewSeek.bind(this)}>
                      <div className="vim-preview-prog-fill" style={{ width:`${previewPct}%` }} />
                      <div className="vim-preview-prog-ball" style={{ left:`${previewPct}%` }} />
                    </div>
                    <span className="vim-preview-timedisp">{this.formatTime(previewTime)} / {this.formatTime(previewDuration)}</span>
                  </div>
                </div>
                <div className="vim-preview-comments-col">
                  <div className="vim-preview-comments-hdr">修正指示（再生時間順）</div>
                  <div className="vim-preview-clist">
                    {previewComments.length === 0 && (
                      <p style={{ fontSize:11, color:'#555', textAlign:'center', marginTop:20 }}>修正指示はまだありません</p>
                    )}
                    {previewComments.map((c) => (
                      <div className="vim-preview-citem" key={c.id}
                        onClick={() => {
                          const vid = this.previewVideoRef.current;
                          const t = c.timeSec || 0;
                          if (vid && isFinite(t)) { vid.currentTime = t; this.setState({ previewTime: t }); this._drawPreviewAnnotations(t); }
                        }}>
                        <div className="vim-preview-ctimecode">
                          ⏱ {c.timecode}
                          {c.annotations && c.annotations.length > 0 && (
                            <span style={{ marginLeft:6, fontSize:9, color:'#555' }}>🖊 描き込みあり</span>
                          )}
                        </div>
                        <div className="vim-preview-cuserrow">
                          {c.avatar
                            ? <img src={c.avatar} className="vim-preview-cavatar" alt="avatar" />
                            : <div style={{ width:18, height:18, borderRadius:'50%', background:'#333', flexShrink:0 }} />}
                          <span className="vim-preview-cname">{c.author}</span>
                        </div>
                        {c.content && <p className="vim-preview-ctext">{c.content}</p>}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default VideoInstructionModal;
